module.exports = __webpack_public_path__ + "img/logo-dark.e5d8013f.svg";